// ── RrStatusCell — workflow status, with the closure phrase for closed rows (SS2B-2b, Phase 1) ──
//
// Non-closed → the existing StatusBadge, exactly as it renders elsewhere (via rrBadgeStatus). Closed
// → the closure reason EXTENDS the closed status into ONE chip "Closed — <reason>" (honesty anchors
// 6 + 7): never a separate badge, never a colour of its own beyond the family tone (remediated=green,
// expired/revoked=warning, everything else incl. replaced_by_renewal=neutral slate). A closed row
// with NO stored reason reads "Closed — reason not recorded" in muted text — never invented, never
// falls back to Other.

import { Badge } from '@/components/ui/badge';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { rrBadgeStatus } from './rrBadgeStatus';
import { RR_CLOSURE_SPECS } from './rrPresentation';

// Structural (string) shape — works for both RaEntry and the slim RenewalLineageEntry.
interface RrStatusEntry {
  workflow_status: string;
  closure_reason: string | null;
}

export function RrStatusCell({ entry }: { entry: RrStatusEntry }) {
  if (entry.workflow_status !== 'closed') {
    return <StatusBadge status={rrBadgeStatus(entry.workflow_status, entry.closure_reason)} />;
  }

  const spec = entry.closure_reason ? RR_CLOSURE_SPECS[entry.closure_reason] : undefined;
  if (!spec) {
    return <Badge variant="muted">Closed — reason not recorded</Badge>;
  }
  return <Badge variant={spec.variant}>Closed — {spec.label}</Badge>;
}
